import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { TREE_CODE_LABEL_LAYER_ID } from './useConfigureMapLayers'

/**
 * Etiquetas de código de árbol: muestra u oculta la capa según el control del
 * mapa (deshabilitado por defecto). Único escritor de su visibilidad.
 *
 * Solo alterna `visibility`: oculta, la capa no genera ni coloca etiquetas. El
 * zoom mínimo (primer zoom sin clusters) lo define la capa en
 * useConfigureMapLayers. `layersReady` como dependencia reaplica el estado tras
 * recargas de estilo, porque la capa se recrea oculta.
 */
export const useTreeCodeLabels = (map, layersReady) => {
  const treeCodeLabelsEnabled = useSelector(state => state.mapState.treeCodeLabelsEnabled)

  useEffect(() => {
    if (!map || !layersReady) return

    try {
      if (map.getLayer(TREE_CODE_LABEL_LAYER_ID)) {
        map.setLayoutProperty(
          TREE_CODE_LABEL_LAYER_ID,
          'visibility',
          treeCodeLabelsEnabled ? 'visible' : 'none',
        )
      }
    } catch (error) {
      console.error('[useTreeCodeLabels] Error:', error)
    }
  }, [map, layersReady, treeCodeLabelsEnabled])
}

export default useTreeCodeLabels
